<div class="td-wb-fpl-faq">
  <h2 class="td-wb-fpl-faq__title"
      translate="tdWb.fpl.faqSection.TITLE"></h2>
  <td-wb-expandable-panel [isExtended]="true"
                          iconType="caret"
                          [hasDivider]="true"
                          [taggingEventName]="'stocklending:faq:' + ('tdWb.fpl.faqSection.FAQ_QUESTION_1' | translate)">
        <span td-wb-expandable-label
              class="td-wb-fpl-faq__header"
              translate="tdWb.fpl.faqSection.FAQ_QUESTION_1"></span>
    <p class="td-wb-fpl-faq__body"
       translate="tdWb.fpl.faqSection.FAQ_ANSWER_1"></p>
    <p class="td-wb-fpl-faq__body"
       translate="tdWb.fpl.faqSection.FAQ_ANSWER_1_2"></p>
    <span class="td-wb-fpl-faq__body"
          translate="tdWb.fpl.faqSection.FAQ_ANSWER_1_3"></span>
  </td-wb-expandable-panel>
  <td-wb-expandable-panel [isExtended]="true"
                          iconType="caret"
                          [hasDivider]="true"
                          [taggingEventName]="'stocklending:faq:' + ('tdWb.fpl.faqSection.FAQ_QUESTION_2' | translate)">
        <span td-wb-expandable-label
              class="td-wb-fpl-faq__header"
              translate="tdWb.fpl.faqSection.FAQ_QUESTION_2"></span>
    <span class="td-wb-fpl-faq__body"
          translate="tdWb.fpl.faqSection.FAQ_ANSWER_2"></span>
  </td-wb-expandable-panel>
   @if (displayAll() || showViewLess) {
      <td-wb-expandable-panel [isExtended]="true"
                              iconType="caret"
                              [hasDivider]="true"
                              [taggingEventName]="'stocklending:faq:' + ('tdWb.fpl.faqSection.FAQ_QUESTION_3' | translate)">
            <span td-wb-expandable-label
                  class="td-wb-fpl-faq__header"
                  translate="tdWb.fpl.faqSection.FAQ_QUESTION_3"></span>
         <p class="td-wb-fpl-faq__body"
            translate="tdWb.fpl.faqSection.FAQ_ANSWER_3"></p>
         <span class="td-wb-fpl-faq__body"
               translate="tdWb.fpl.faqSection.FAQ_ANSWER_3_2"></span>
      </td-wb-expandable-panel>
      <td-wb-expandable-panel [isExtended]="true"
                              iconType="caret"
                              [hasDivider]="true"
                              [taggingEventName]="'stocklending:faq:' + ('tdWb.fpl.faqSection.FAQ_QUESTION_4' | translate)">
            <span td-wb-expandable-label
                  class="td-wb-fpl-faq__header"
                  translate="tdWb.fpl.faqSection.FAQ_QUESTION_4"></span>
         <p class="td-wb-fpl-faq__body"
            translate="tdWb.fpl.faqSection.FAQ_ANSWER_4_SUBHEAD_1"></p>
         <p class="td-wb-fpl-faq__body"
            translate="tdWb.fpl.faqSection.FAQ_ANSWER_4_COPY_1"></p>
         <p class="td-wb-fpl-faq__body"
            translate="tdWb.fpl.faqSection.FAQ_ANSWER_4_SUBHEAD_2"></p>
         <p class="td-wb-fpl-faq__body"
            translate="tdWb.fpl.faqSection.FAQ_ANSWER_4_COPY_2"></p>
         <p class="td-wb-fpl-faq__body"
            translate="tdWb.fpl.faqSection.FAQ_ANSWER_4_SUBHEAD_3"></p>
         <p class="td-wb-fpl-faq__body"
            translate="tdWb.fpl.faqSection.FAQ_ANSWER_4_COPY_3"></p>
         <p class="td-wb-fpl-faq__body"
            translate="tdWb.fpl.faqSection.FAQ_ANSWER_4_COPY_3_1"></p>
         <p class="td-wb-fpl-faq__body"
            translate="tdWb.fpl.faqSection.FAQ_ANSWER_4_COPY_3_2"></p>
         <span class="td-wb-fpl-faq__body"
               translate="tdWb.fpl.faqSection.FAQ_ANSWER_4_COPY_3_3"></span>
      </td-wb-expandable-panel>
      <td-wb-expandable-panel [isExtended]="true"
                              iconType="caret"
                              [hasDivider]="true"
                              [taggingEventName]="'stocklending:faq:' + ('tdWb.fpl.faqSection.FAQ_QUESTION_5' | translate)">
            <span td-wb-expandable-label
                  class="td-wb-fpl-faq__header"
                  translate="tdWb.fpl.faqSection.FAQ_QUESTION_5"></span>
         <span class="td-wb-fpl-faq__body"
               translate="tdWb.fpl.faqSection.FAQ_ANSWER_5"></span>
      </td-wb-expandable-panel>
   }
   @if (!displayAll()) {
      <div class="td-wb-fpl-faq__view-more">
         <td-wb-view-more buttonId="td-wb-fpl-faq-view-more-button"
                          [viewLess]="true"
                          size="12"
                          (clicked)="toggleViewMore()" />
      </div>
   }
</div>